/// <amd-module name="TFS/Admin/Views/ProjectGroups/Components/ProjectsHub" />
import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ConnectedProjectsPageContentView } from "TFS/Admin/Views/ProjectGroups/Components/ProjectsPageContentView";
import { getProjectGroupsModule } from "TFS/Admin/Views/ProjectGroups/redux/ProjectGroupsModule";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";
import { IRootProviderProps, RootProvider } from "VSS/Redux/RootProvider";
import { getProjectsHubRootProviderProps, IProjectsHubSagaContext } from "TFS/Admin/Views/ProjectGroups/redux/ProjectGroupsRootProviderProps";

export interface IProjectPermissionsProps {}

export class ProjectsHub extends VssComponent<IProjectPermissionsProps> {
    private _hubViewState: VssHubViewState;
    private _context: IVssComponentContext;
    private rootProviderProps: IRootProviderProps<IProjectsHubSagaContext, any>;

    constructor(props: IProjectPermissionsProps, context: IVssComponentContext) {
        super(props, context);

        this._context = context;

        this.rootProviderProps = getProjectsHubRootProviderProps(this.context.pageContext);
    }

    public render(): JSX.Element {
        this._initializeHubState(this._context);

        return (
            <RootProvider {...this.rootProviderProps}>
                <DynamicModuleLoader modules={[getProjectGroupsModule()]}>
                    <ConnectedProjectsPageContentView hubViewState={this._hubViewState} context={this._context} />
                </DynamicModuleLoader>
            </RootProvider>
        );
    }

    // Hub initializer functions
    private _initializeHubState(context: IVssComponentContext): void {
        this._hubViewState = new VssHubViewState(context.pageContext);
    }
}

VssComponent.register("ms.vss-admin-web.project-groups-component", ProjectsHub);
